<template>
  <div class="form-table">
    <!-- 表单 -->
    <el-form ref="elForm" :model="formData" inline label-width="auto">
      <el-form-item label="商品名称:" prop="productName">
        <el-input v-model="formData.productName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="商品类型:" prop="categoryIds">
        <el-cascader v-model="formData.categoryIds" :options="categoryTypes" :props="{ checkStrictly: true }"
          clearable></el-cascader>
      </el-form-item>
      <el-form-item label="商品状态:" prop="isOnShelf">
        <el-select v-model="formData.isOnShelf" placeholder="请选择" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品分类:" prop="displayCategoryId">
        <el-select v-model="formData.displayCategoryId" placeholder="请选择商品分类" style="width: 100%;">
          <el-option :label="pItem.name" :value="pItem.display_category_id" v-for="(pItem, pIndex) in categoryList"
            :key="pIndex" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="handleSubmitForm">查询</el-button>
        <el-button :loading="loading" @click="handleResetForm">重置</el-button>
      </el-form-item>

      <div class="form-buttons">
        <el-button type="primary" :loading="loading" @click="handleAdd">新增</el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" class="table" :data="tableData" height="100%" border stripe>
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <el-table-column prop="sort" label="排序权重" align="center" width="70"></el-table-column>      
      <el-table-column prop="productName" label="商品名称" align="center"></el-table-column>
      <el-table-column prop="mainImage" label="商品主图" align="center">
        <template slot-scope="scope">
          <s-img :src="scope.row.mainImage" alt="" style="width: 50px;" />
        </template>
      </el-table-column>
      <el-table-column prop="displayCategoryName" label="商品分类" align="center" width="100"></el-table-column>
      <el-table-column prop="productCategoryName" label="商品大类" align="center"></el-table-column>
      <el-table-column prop="productTwoName" label="商品功效" align="center"></el-table-column>
      <el-table-column prop="isOnShelf" label="商品状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isOnShelf == 1" type="success">上架</el-tag>
          <el-tag v-else type="danger">下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="商品更新时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRowEdit(scope)">
            编辑
          </el-button>
          <el-popconfirm title="确认删除？" @confirm="handleRowDel(scope)">
            <el-button class="ml10" slot="reference" type="text" size="small" :style="{ color: '#f00' }">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="table-page">
      <el-pagination :current-page="pageData.current" :page-size="pageData.size" :total="total"
        :page-sizes="[20, 50, 100, 200]" :disabled="loading" background layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- 弹窗 -->
    <form-dlg v-model="showDlg" :data="currentRowData" :categoryTypes="categoryTypes" :categoryList="categoryList"
      @submit-form="dlgSubForm"></form-dlg>
  </div>
</template>

<script>
import FormDlg from './components/form-dlg.vue'
import { getPro, get_categories_options, delPro } from '@/api'
import SImg from '@/components/s-img'

export default {
  name: 'form-table',
  components: {
    FormDlg,
    SImg,
  },
  props: {},
  data() {
    return {
      loading: false,
      showDlg: false,
      formData: {},
      tableData: [],
      currentRowData: {},
      pageData: {
        current: 1,
        size: 50,
      },
      total: 0,
      categoryTypes: [],
      statusList: [
        {
          label: '未上架',
          value: 0,
        },
        {
          label: '已上架',
          value: 1,
        },
      ],
      categoryList: [],
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getTableData()
    this.getOptions()
    this.getCategoryList()
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    async getCategoryList() {
      const res = await this.$request.get("/cms/ordinary_product/cms_product/display_category")
      if (res.data.code === 200) {
        this.categoryList = res.data.data || []
      }
    },
    // 表单查询
    handleSubmitForm() {
      this.getTableData(1)
    },

    // 重置表单
    handleResetForm() {
      this.$refs.elForm.resetFields()
      this.getTableData(1)
    },

    // 添加
    handleAdd() {
      this.currentRowData = {}
      this.showDlg = true
    },

    // 表格行-编辑
    handleRowEdit(data) {
      const { row } = data

      this.currentRowData = { ...row }
      this.showDlg = true
    },

    // 表格行-删除
    handleRowDel(data) {
      const { row } = data

      delPro({
        id: row.id,
      }).then(res => {
        this.$message.success('删除成功')
        this.getTableData()
      })
    },

    // 分页-改变页码大小
    handleSizeChange(size) {
      this.pageData.size = size

      this.getTableData(1)
    },

    // 分页-改变当前页
    handleCurrentChange(current) {
      this.getTableData(current)
    },

    // 弹窗表单提交
    dlgSubForm() {
      if (this.currentRowData.id || this.currentRowData.id === 0) {
        this.getTableData()
      } else {
        this.getTableData(1)
      }
    },

    // 获取表格数据
    getTableData(current) {
      this.loading = true
      current && (this.pageData.current = current)

      getPro({
        ...this.formData,
        ...this.pageData,
      }).then(res => {
        const { records = [], total } = res || {}

        this.tableData = records.map(item => {
          return {
            ...item,
            id: item.productId,
          }
        })
        this.total = total
        this.loading = false
      })
    },

    recursive(arr = []) {
      if (!arr.length) return

      return arr.map(item => {
        return {
          ...item,
          label: item.categoryName,
          value: item.categoryId,
          children: this.recursive(item.children),
        }
      })
    },

    async getOptions() {
      try {
        const options = await get_categories_options()

        this.categoryTypes = this.recursive(options)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
